module.exports = __webpack_public_path__ + "img/together-alone-visual.0104df8e.png";